package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 菜单 overlay 内容的解析期 AST。
 *
 * 块内支持任意 DSL 布局，[root] 是菜单内容的根元素。
 */
data class MenuContentAst(
    val kind: Kind,
    val props: List<ElementAst.PropAssign>,
    val root: ElementAst,
    override val position: SourcePosition,
) : AstNode {

    /** 菜单 overlay 种类。 */
    enum class Kind {
        RIGHT_CLICK_MENU,
        CONTEXT_MENU,
    }
}
